import React from 'react';
import type { PickingInfo } from '@deck.gl/core';
import { Box, Paper, Button } from '@mui/material';
import type { GeoJsonFeature } from '../../utils/ogc';
import type { AugmentedSensorFeature } from '../../layers/sensor_locations';
import { format } from 'date-fns';
import EventIcon from '@mui/icons-material/Event';
import LocationPinIcon from '@mui/icons-material/LocationPin';
import MiniDepthChart from '../charts/MiniDepthChart';




export const HoverPopup = ({ info }: { info: PickingInfo<GeoJsonFeature> }) => {
  if (!info?.object) return null
  const p = info.object.properties as GeoJsonFeature['properties'];
  return (
    // transform: 'translate(0, -10px)', pointerEvents: 'none', background: 'rgba(17,24,39,0.92)', color: 'white', padding: '8px 10px', borderRadius: 8, fontSize: 14, boxShadow: '0 6px 18px rgba(0,0,0,0.25)', maxWidth: 260, textAlign: 'center', whiteSpace: 'nowrap'
    // background: 'rgba(17,24,39,0.92)', color: 'white', padding: '8px 10px', borderRadius: 8, fontSize: 14, boxShadow: '0 6px 18px rgba(0,0,0,0.25)', maxWidth: 260, textAlign: 'center', whiteSpace: 'nowrap'
      <Paper elevation={0} sx={{
        fontSize: 14,
        padding: '3px 10px',
        borderRadius: '6px',
        bgcolor: 'background.opaque',
        // backgroundColor: 'rgba(17,24,39,0.92)',
        // color: 'white',
        maxWidth: 260,
        textAlign: 'center',
        whiteSpace: 'nowrap',
        boxShadow: '0 6px 18px rgba(0,0,0,0.25)',
      }}>
        <div style={{ fontWeight: 700 }}>{p.name}</div>
      </Paper>
  )
}

export const SelectedPopup = ({ info, features, onClose, timeRange, currentTime, detailed }: { info: PickingInfo, features: AugmentedSensorFeature[], onClose?: () => void; timeRange: [Date, Date, boolean]; currentTime?: Date }) => {
  const [fromTime, toTime] = timeRange;
  // const feature = info.object as GeoJsonFeature;
  const p = info.object.properties as GeoJsonFeature['properties'];

  // If the selected feature is a point without series, try to fetch the series for its deployment within [from,to]
  const deploymentId = p?.id as string | undefined
  const seriesFeatures = React.useMemo(() => features?.filter((f: AugmentedSensorFeature) => f?.properties?.id === deploymentId), [features, deploymentId]);
  const [detailsOpen, setDetailsOpen] = React.useState(false);

  return (
    <Box sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    }}>
    <Paper elevation={6} sx={{
      fontSize: 14,
      // px: 2,
      // py: 2,
      p: 1,
      backgroundColor: 'background.opaque',
      borderRadius: '8px',
      // backgroundColor: 'rgba(17,24,39,0.92)',
      // color: 'white',
      // backgroundColor: '#ffffff',
      // backdropFilter: 'blur(8px) saturate(1.05)',
      // WebkitBackdropFilter: 'blur(8px) saturate(1.05)',
    //   border: '1px solid rgba(0,0,0,0.22)',
      maxWidth: 320,
      // textAlign: 'center',
      whiteSpace: 'nowrap',
      // boxShadow: '0 6px 18px rgba(0,0,0,0.25)',
      
    }}>
      {(detailed) ? <>
        <Box style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontWeight: 700, marginBottom: 4, color: 'text.primary' }}>
          <span>{p.name || p.deployment_id || 'Sensor'}</span>
          <Button size="small" variant="text" sx={{ minWidth: '24px', padding: 0, color: 'text.primary', position: 'absolute', top: -5, right: -5 }} aria-label="Close popup" onClick={(e) => {
            onClose?.();
            e.stopPropagation();
          }}>×</Button>
        </Box>
        {p.borough && <div><LocationPinIcon sx={{ fontSize: 13 }} /> {p.neighborhood} {p.borough}</div>}
        {p.start_time && <div><EventIcon sx={{ fontSize: 13 }} /> Deployed On: <b>{format(new Date(p.start_time), 'MMMM d, yyyy')}</b></div>}
        {(seriesFeatures && seriesFeatures.length > 0 && fromTime && toTime) && (
          <Box sx={{ mt: 1, mb: 0.5 }}>
            <MiniDepthChart
              timeRange={timeRange}
              height={76}
              currentTime={currentTime}
              // show only the selected feature's series
              features={seriesFeatures as GeoJsonFeature[]}
              // highlightedKey={p.deployment_id || p.id}
            />
            {/* <Box sx={{ display: 'flex', gap: 1, mt: 1 }}>
              <Button variant="contained" size="small" sx={{ textTransform: 'none', width: '100%' }} onClick={() => setDetailsOpen(true)}>View Data</Button>
            </Box> */}
          </Box>
        )}
      </> : (
        <span>{p.name || p.deployment_id || 'Sensor'}</span>
      )}
    {/* {p.start_time && <div>Deployed On: {new Date(p.start_time).toLocaleString()}</div>} */}
    {/* {p.max_depth_inches != null && <div>Max Depth: {Number(p.max_depth_inches).toFixed(1)} in</div>}
    {p.max_depth_time && <div>Peak: {new Date(p.max_depth_time).toLocaleString()}</div>}
    {p.end_time && <div>End: {new Date(p.end_time).toLocaleString()}</div>} */}
    {/* Arrow below the popup */}
    {/* <code>
      <pre>
        {JSON.stringify(p, null, 2)}
      </pre>
    </code> */}
    {/* <Box sx={{
      position: 'absolute',
      left: '50%',
      transform: 'translateX(-50%)',
      top: '100%',
      width: 0,
      height: 0,
      borderLeft: '8px solid transparent',
      borderRight: '8px solid transparent',
      borderTop: '8px solid transparent',
      borderTopColor: 'background.paper',
      // slight shadow to match Paper
      filter: 'drop-shadow(0 2px 6px rgba(0,0,0,0.12))',
    }} /> */}
    </Paper>
    <Box sx={{
      width: '2px',
      height: '48px',
      // backgroundColor: 'background.paper',
      bgcolor: 'red',
      mb: 1,
      // borderLeft: '2px solid transparent',
      // borderRight: '2px solid transparent',
      // borderTop: '15px solid transparent',
      // borderTopColor: 'background.paper',
      // slight shadow to match Paper
      // filter: 'drop-shadow(0 2px 6px rgba(0,0,0,0.12))',
    }} />
    {/* <SensorDetailsDrawer open={detailsOpen} onClose={() => setDetailsOpen(false)} info={info} timeRange={timeRange} currentTime={currentTime} /> */}
    </Box>
  )
}
